import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { ArrowLeft } from 'lucide-react';

const PrivacyPage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-dvh bg-background font-sans">
      <Helmet>
        <title>Política de Privacidad | Museo de la Fe</title>
        <meta name="description" content="Política de privacidad de Museo de la Fe. Cómo protegemos tus datos personales." />
        <link rel="canonical" href="https://museodelafe.com/privacidad" />
      </Helmet>
      <Header />
      <div className="max-w-xl mx-auto px-6 pt-8 pb-20">
        <button onClick={() => navigate(-1)} className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors mb-6"><ArrowLeft className="size-4" /> Volver</button>
        <h1 className="text-2xl font-bold mb-6">Política de Privacidad</h1>
        <div className="space-y-6 text-sm text-muted-foreground leading-relaxed">
          <p><strong className="text-foreground">Última actualización:</strong> Abril 2026</p>
          <section>
            <h2 className="text-base font-semibold text-foreground mb-2">1. Información que recopilamos</h2>
            <p>Cuando te registras en Museo de la Fe mediante Google OAuth, recopilamos tu nombre, dirección de correo electrónico y foto de perfil. Al realizar una compra, procesamos la información de pago a través de PayPal (no almacenamos datos de tarjetas). También recopilamos información sobre cómo nos encontraste al registrarte por primera vez.</p>
          </section>
          <section>
            <h2 className="text-base font-semibold text-foreground mb-2">2. Cómo usamos tu información</h2>
            <p>Usamos tu información para: gestionar tu cuenta y biblioteca personal, procesar compras y regalos, enviarte novedades si te suscribes a nuestro correo, mejorar nuestros productos y servicio, y responder a tus reseñas y consultas.</p>
          </section>
          <section>
            <h2 className="text-base font-semibold text-foreground mb-2">3. Protección de datos</h2>
            <p>Tus datos se almacenan de forma segura en MongoDB Atlas con encriptación en tránsito. Las contraseñas y tokens de sesión se manejan mediante Google OAuth y cookies seguras (HttpOnly, Secure, SameSite). Nunca almacenamos datos de tarjetas de crédito.</p>
          </section>
          <section>
            <h2 className="text-base font-semibold text-foreground mb-2">4. Terceros</h2>
            <p>Compartimos datos únicamente con: Google (autenticación), PayPal (procesamiento de pagos) y Cloudflare (almacenamiento de imágenes). No vendemos ni compartimos tu información personal con terceros con fines publicitarios.</p>
          </section>
          <section>
            <h2 className="text-base font-semibold text-foreground mb-2">5. Tus derechos</h2>
            <p>Puedes solicitar acceso, corrección o eliminación de tus datos personales en cualquier momento escribiendo a admin@museodelafe.com. Puedes cerrar sesión y dejar de usar el servicio cuando lo desees.</p>
          </section>
          <section>
            <h2 className="text-base font-semibold text-foreground mb-2">6. Cookies</h2>
            <p>Usamos cookies esenciales para mantener tu sesión activa. No usamos cookies de publicidad ni de rastreo de terceros.</p>
          </section>
          <section>
            <h2 className="text-base font-semibold text-foreground mb-2">7. Contacto</h2>
            <p>Para cualquier consulta sobre privacidad: <a href="mailto:admin@museodelafe.com" className="text-foreground hover:underline">admin@museodelafe.com</a></p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPage;
